// Admin API client — /admin/email-suppressions/* (mirrors the API's email-suppressions aggregate).

import type { AdminEmailSuppressionListResponse } from '@a7y/types';
import { client } from './transport';

export const emailSuppressionsApi = {
  // Email Suppressions
  getEmailSuppressions: (params?: { limit?: number; offset?: number; search?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.offset) searchParams.set('offset', String(params.offset));
    if (params?.search) searchParams.set('search', params.search);
    return client.get<AdminEmailSuppressionListResponse>(`/email-suppressions?${searchParams}`);
  },
  suppressEmail: (email: string) =>
    client.post<{ success: boolean; email: string }>(
      `/email-suppressions/${encodeURIComponent(email)}/suppress`
    ),
  unsuppressEmail: (email: string) =>
    client.post<{ success: boolean; email: string }>(
      `/email-suppressions/${encodeURIComponent(email)}/unsuppress`
    ),
  generatePreferenceLink: (email: string) =>
    client.post<{ url: string; email: string }>('/email-suppressions/generate-link', { email }),
};
